import { Archive, FileJson, FlaskConical, PackageCheck } from "lucide-react";
import { AudioLabDownloadButton } from "./AudioLabDownloadButton";

interface AudioLabHeaderProps {
  busy: boolean;
  totalTestCount: number;
  onDownloadAllZip: () => void;
  onDownloadGlobalPresets: () => void;
  onDownloadGlobalFeatureIndex: () => void;
  onDownloadManifest: () => void;
}

export function AudioLabHeader({
  busy,
  totalTestCount,
  onDownloadAllZip,
  onDownloadGlobalPresets,
  onDownloadGlobalFeatureIndex,
  onDownloadManifest
}: AudioLabHeaderProps) {
  return (
    <section className="audio-lab-hero" aria-labelledby="audio-lab-title">
      <div>
        <p className="eyebrow">Developer Tool</p>
        <h1 id="audio-lab-title">Audio Lab</h1>
        <p>Offline export lab for validating Timbroam's advanced physical/spectral approximation engine.</p>
        <span>{totalTestCount} generated note and articulation checks are available from the current registry.</span>
      </div>
      <div className="audio-lab-global-actions" aria-label="Global Audio Lab exports">
        <AudioLabDownloadButton
          label="Download All Audio Audit ZIP"
          icon={<Archive size={18} aria-hidden="true" />}
          disabled={busy}
          variant="primary"
          onClick={onDownloadAllZip}
        />
        <AudioLabDownloadButton
          label="Download Global Presets JSON"
          icon={<FileJson size={18} aria-hidden="true" />}
          disabled={busy}
          onClick={onDownloadGlobalPresets}
        />
        <AudioLabDownloadButton
          label="Download Global Feature Index JSON"
          icon={<PackageCheck size={18} aria-hidden="true" />}
          disabled={busy}
          onClick={onDownloadGlobalFeatureIndex}
        />
        <AudioLabDownloadButton
          label="Download Audio Lab Manifest JSON"
          icon={<FlaskConical size={18} aria-hidden="true" />}
          disabled={busy}
          onClick={onDownloadManifest}
        />
      </div>
    </section>
  );
}
